import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Utilities from '@/Utility/Utilities';

/**
 * Das ViewModel für die BreadCrumb
 */
export default class BreadCrumbViewModel extends ControlViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Die Elemente im BreadCrumb
     */
    public elements: KnockoutObservable<Array<LabelViewModel>>;

    /**
     * Das ViewModel für die BreadCrumb
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        
        this.elements = this.observableOrDefault(params.elements, []);
        // Der nachfolgende Code war hier einmal.
        // Probleme darin:
        // - Das postfix wird hier einfach ersetzt, dadurch wird das computed welches die tatsächliche caption berechnet
        //   nicht neu getriggert und das postfix ist somit nie zu sehen (tatsächlich sieht BreadCrumb.js auch selbst vor dies zu rendern)
        // - Das postfix wird in die Elemente gesetzt, die auch über elements erreichbar sind.

        ///*
        // * Die konvertierten Elemente im BreadCrumb
        // */
        //self.convertedElements = self.defineComputed(function () {
        //    var convertedElements = [];
        //    var elements = self.elements();

        //    for (var i = 0; i < elements.length; i++) {
        //        var element = elements[i];

        //        if (i < elements.length - 1) {
        //            element.postfix = new LabelViewModel({
        //                caption: '<span> &raquo; </span>'
        //            });
        //        }

        //        convertedElements.push(element);
        //    }

        //    return convertedElements;
        //});
    }

    /**
     * Repräsentation als String
     */
    public toString(): string {
        let elements = this.elements();

        var captions = elements.map((element) => element.caption()).filter((caption) => {
            return !Utilities.isNullOrUndefinedOrBlank(caption);
        });

        return captions.join(' > ');
    }
}

ComponentManager.setViewModel('BreadCrumbViewModel', BreadCrumbViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');